import { Link } from 'react-router-dom';
import { motion } from 'framer-motion';

export default function HeroSection() {
  return (
    <section className="relative h-[85vh] sm:h-screen flex items-center justify-center overflow-hidden">
      {/* Background Image */}
      <div className="absolute inset-0">
        <img
          src="https://public.readdy.ai/ai/img_res/06b354efe883fca710d299717c40dac9.jpg"
          alt="Hero Background"
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/40 via-black/30 to-black/40"></div>
      </div>

      {/* Floating Yarn Balls Animation — hidden on mobile for performance */}
      <div className="absolute inset-0 pointer-events-none hidden sm:block">
        {[...Array(6)].map((_, i) => (
          <motion.div
            key={i}
            className="absolute w-16 h-16 opacity-20"
            style={{ left: `${10 + i * 15}%` }}
            initial={{ y: -100 }}
            animate={{
              y: ['0%', '100%'],
              x: [0, (i % 2 === 0 ? 30 : -30)],
            }}
            transition={{
              duration: 15 + i * 2,
              repeat: Infinity,
              delay: i * 2,
            }}
          >
            <i className="ri-ball-pen-line text-6xl text-white"></i>
          </motion.div>
        ))}
      </div>

      {/* Content */}
      <div className="relative z-10 text-center px-5 sm:px-6 max-w-5xl mx-auto w-full">
        <motion.h1
          className="font-heading font-bold text-3xl sm:text-5xl md:text-6xl lg:text-8xl text-white mb-4 sm:mb-6 tracking-wide leading-tight"
          initial={{ opacity: 0, y: 30 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8 }}
        >
          THE CUTEST CATS
          <br />
          ON THE INTERNET
        </motion.h1>

        <motion.p
          className="font-body text-sm sm:text-lg md:text-xl lg:text-2xl text-white/90 mb-8 sm:mb-12 max-w-3xl mx-auto"
          initial={{ opacity: 0, y: 30 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8, delay: 0.2 }}
        >
          Watch endless adorable videos • Shop premium cat products • Join the purr-fect community
        </motion.p>

        <motion.div
          className="flex flex-col sm:flex-row gap-3 sm:gap-6 justify-center items-center"
          initial={{ opacity: 0, y: 30 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8, delay: 0.4 }}
        >
          <Link
            to="/videos"
            className="w-full sm:w-auto px-8 sm:px-10 py-4 sm:py-5 bg-accent hover:bg-accent/90 text-white font-heading font-bold text-base sm:text-lg rounded-full transition-all duration-300 hover:scale-105 flex items-center justify-center gap-3 shadow-2xl whitespace-nowrap cursor-pointer"
          >
            <i className="ri-play-circle-line text-xl sm:text-2xl"></i>
            Watch Videos Now
            <i className="ri-arrow-right-line text-lg sm:text-xl"></i>
          </Link>
          <Link
            to="/shop"
            className="w-full sm:w-auto px-8 sm:px-10 py-4 sm:py-5 bg-transparent border-2 sm:border-3 border-white text-white hover:bg-white hover:text-primary font-heading font-bold text-base sm:text-lg rounded-full transition-all duration-300 hover:scale-105 flex items-center justify-center gap-3 whitespace-nowrap cursor-pointer"
          >
            <i className="ri-shopping-bag-3-line text-xl sm:text-2xl"></i>
            Shop The Purr-fection
          </Link>
          <Link
            to="/adopt"
            className="w-full sm:w-auto px-8 sm:px-10 py-4 sm:py-5 bg-rose-500 hover:bg-rose-600 text-white font-heading font-bold text-base sm:text-lg rounded-full transition-all duration-300 hover:scale-105 flex items-center justify-center gap-3 shadow-2xl whitespace-nowrap cursor-pointer"
          >
            <i className="ri-heart-3-fill text-xl sm:text-2xl"></i>
            Adopt Today!
          </Link>
        </motion.div>

        {/* Floating Paw Prints — hidden on mobile */}
        <div className="absolute -bottom-20 left-1/2 transform -translate-x-1/2 hidden sm:flex gap-8">
          {[...Array(5)].map((_, i) => (
            <motion.i
              key={i}
              className="ri-footprint-line text-4xl text-white/30"
              animate={{ y: [0, -20, 0] }}
              transition={{
                duration: 2,
                repeat: Infinity,
                delay: i * 0.2,
              }}
            ></motion.i>
          ))}
        </div>
      </div>

      {/* Scroll Indicator */}
      <motion.div
        className="absolute bottom-6 sm:bottom-10 left-1/2 transform -translate-x-1/2"
        animate={{ y: [0, 10, 0] }}
        transition={{ duration: 2, repeat: Infinity }}
      >
        <i className="ri-arrow-down-line text-3xl sm:text-4xl text-white/70"></i>
      </motion.div>
    </section>
  );
}